<template>
    <el-dialog class="el-dialogs" :title="title" width="50%" :append-to-body="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <iframe id="frame" allowfullscreen="true" :src="fileUrl"
                style="width: 100%;height: 500px"></iframe>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="downFile()">下载</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {Base64} from "js-base64";
import {onlinePreview} from "@/utils";

export default {
    name: "seeFileDetail",
    data() {
        return {
            title: '质量检测报告单',
            visible: false,
            fileUrl: '',
            fileUrlAdd: {},
        }
    },

    methods: {
        init(row) {
            console.log(row)
            this.fileUrlAdd = row
            this.visible = true
            this.onlinePreview(row.inspectionReport, row.resourcesName).then(res=>{
                this.fileUrl = res
            })
        },

        downFile() {
            this.fileBlobDownload(this.api.academic.downloadReport, {
                id:this.fileUrlAdd.id,
            }, this.fileUrlAdd.resourcesName+".pdf", 'application/pdf','get')
        },
    },
}
</script>

<style scoped>

</style>
